<template>
    <NotificationTile @click="tileClicked()" :isNotificationRead="isNotificationRead">

        <template v-slot:icon>
            <TileIcon :size="50">
                <SafeImage :src="notification.body.offerImageUrl"></SafeImage>
            </TileIcon>
        </template>



        <template v-slot:title>
            {{ notification.body.earnOptionName }}
        </template>
        <template v-slot:description>
            {{ formatTime(notification.createdAt) }}
        </template>



        <template v-slot:coins>
            {{ notification.body.coinsAmount }}
        </template>


    </NotificationTile>
</template>



<script lang="ts">

import { useRouter } from 'vue-router';
import { formatDistanceToNow } from 'date-fns';
import TileIcon from '@/components/Common/Tile-Icon.vue';
import SafeImage from '@/components/Common/SafeImage.vue';
import { defineComponent, PropType, computed } from 'vue';
import IOfferNotification from '@/interfaces/Notifications/IOfferNotification';
import NotificationTile from '@/components/Tiles/Notification/NotificationTile.vue';

export default defineComponent({
    name: 'OfferNotificationTile',
    components: {
        TileIcon,
        SafeImage,
        NotificationTile,
    },
    props: {
        notification: {
            type: Object as PropType<IOfferNotification>,
            required: true,
        },
    },
    setup(props) {
        const router = useRouter();

        const isNotificationRead = computed(() => {
            return props.notification.readAt != null;
        });

        const formatTime = (time: number) => {
            return formatDistanceToNow(time * 1000) + ' ago';
        }

        const tileClicked = () => {
            // redirect user to my offers page
            router.push('/status/completed');
        }

        return {
            formatTime,
            tileClicked,
            isNotificationRead,
        };
    },
});

</script>